<template>
    <div class="container">
        <!-- <img alt="Vue logo" src="../assets/logo.png"> -->
        
      <div  class="row">
        <div class="twelve">
          <div id="trail">
              <ul>
                  <li><a href="https://www.brighton.com/">Home</a></li>
                  <li><a href="https://www.brighton.com/powerofpink/">Power Of Pink</a></li>
                  <!-- <li><a href="../brighton-cares">The Butterfly Ribbon</a></li> -->
                  <li><router-link to="/submit">Post your dedication</router-link></li>
              </ul>
          </div>
          <div class="staticPopTextWrapper">
              <span class="popButterflyTopLargeText">POWER</span>
              <span class="popButterflyTopSmallText">of</span><span class="popButterflyTopLargeText">&nbsp;PINK</span><br />
              <span class="popButterflyTopYears">20 Years of Giving</span><br />
              <span class="popButterflyTopRecognition">In recognition of Breast Cancer Awareness Month we would like to remember and honor members of our extended Brighton family</span>
          </div>
          <div class="confirmation" v-if="submitted">
            <span style="width: 300px;margin: 0 auto;">Your submission has been received and will be reviewed</span>
            <img v-if="$store.state.previewImageSrcDataURL != ''" :src="$store.state.previewImageSrcDataURL" alt="" class="logoImg logoImg2" /> 
            <img v-else-if="noteType == 0" :src="base_url+'heart_icon.png'" alt="">
            <img v-else :src="base_url+'heart_icon2.png'" alt="">
            <span style="width: 300px;margin: 0 auto;display:block;padding:20px 0;">This would look lovely inside one of our Love Lockets</span>
            <button><a href="https://app.brighton.com/lockets/create/1/JM1743"><img :src="base_url+'qijm1743_01.png'" alt="Loving Heart Convertible Locket Necklace" /> SHOP LOVE LOCKETS</a></button>
            <!-- <button><a href="https://app.brighton.com/lockets/create/1/hp040"><img :src="base_url+'qihp040_01.jpg'" alt="Sweetheart Frame" /> SHOP LOVE LOCKETS AND MORE</a></button> -->
            <div class="social">
              <span>Share with your friends</span>
              <a :href="facebookUrl" target="_new">
                <span class="fa-stack fa-lg">
                  <i class="fa fa-circle fa-stack-2x"></i>
                  <i class="fa fa-facebook  fa-stack-1x fa-inverse"></i>
                </span>
              </a>
              <a :href="twitterUrl" target="_new">
                <span class="fa-stack fa-lg">
                  <i class="fa fa-circle fa-stack-2x"></i>
                  <i class="fa fa-twitter  fa-stack-1x fa-inverse"></i>
                </span>
              </a>
              <a :href="pinterestUrl" target="_new">
                <span class="fa-stack fa-lg">
                  <i class="fa fa-circle fa-stack-2x"></i>
                  <i class="fa fa-pinterest  fa-stack-1x fa-inverse"></i>
                </span>
              </a>
          </div>
          </div>  
          <div v-else id="pop_dedication">
              <div class="errors" v-model="errors" v-if="errors != ''">
                Please compolete the required fields
                <ul>
                  <li v-for="error in errors">
                    {{error}}
                  </li>
                </ul>
              </div>
              <div style="height:12px;clear:both"></div>
              <div class="label"><span>To Whom Is This Dedicated?</span>
                  <input type="text" v-model="firstName" placeholder="First Name*" maxlength="18" style="color: rgb(207, 67, 169);"/>
                  <input type="text" v-model="lastName" placeholder="Last Name* (Initial Only)" style="color: rgb(207, 67, 169);" maxlength="1" />
              </div>
              
              <label><span>Select a note to inlcude with your heart dedication:</span>
                  <span href="#" @click="changeNoteType(0)"  :class="{active: noteType==0}" placeholderel="memory" class="menu">In Memory Of</span>
                  <span href="#" @click="changeNoteType(1)" :class="{active: noteType==1}" placeholder="honor" class="menu">In Honor Of</span>
                  <div style="height:12px;clear:both"></div>
                  <select id="message" v-model="selectedMessage">
                      <!-- <option>Forever In My Heart</option> -->
                      <option v-for="(message, index) in messages[noteType]">{{message}}</option>
                  </select>
              </label>

              <div class="label"><span>Would You Like to Include Your Name?</span>
                  <input type="text" v-model="yourFirstName" id="from_first" placeholder="Your First Name" maxlength="18" />
                  <input type="text" v-model="yourLastName" id="from_last" placeholder="Last Name (Initial Only)" maxlength="1" />
              </div>
              <div class="uploadPhoto">
                <span>OPTIONAL: Upload a photograph</span>
                  <div class="uploadArea" v-if="$store.state.previewImageSrcDataURL == ''">
                    <input id="uploadFile" type="file" @change="prepareFile($event.target.files)"/>
                    <span>Click to upload your file<br/><span style="font-size:10px;">(Supports JPEG / PNG / GIF / BMP image format)</span></span>
                  </div>
                  <div class="uploadArea edit" v-else>
                      <input id="uploadFile" type="file" @change="prepareFile($event.target.files)"/>
                      <span class="text">CHOOSE A DIFFERENT IMAGE</span>
                      <span class="editBtn" @click="editImage">EDIT</span>
                  </div>
                  <div class="uploadedPhoto" v-if="$store.state.previewImageSrcDataURL != ''">
                    <i class="fa fa-times-circle" aria-hidden="true" @click="removeImage"></i>
                    <img :src="$store.state.previewImageSrcDataURL" alt="" class="logoImg logoImg2" /> 
                  </div>
                </div>
                <label class="emailSignup">
                  <span>Would you like to sign up to receive Power of Pink campaign progress emails and other promotional alerts from Brighton?</span>
                  <input type="email" v-model="email" placeholder="Email address">
                  <span class="remark">We will NOT share your email address with third parties. <a href="https://www.brighton.com/content/privacy" target="_new">(privacy policy)</a></span>
                </label>
              <button class="submitBtn" type="submit" @click="submitDedication()"><span v-if="loading">Please wait ...</span><span v-else>Submit Your Dedication</span></button>
            </div>
          </div>
      </div>
  </div>
</template>

<script>
  import imageCropper from '@/components/HomeImageCropper'

//   import Cropper from 'cropperjs';
// import 'cropperjs/dist/cropper.min.css'
// import 'cropperjs/dist/cropper.min.js'


const axios = require('axios');
export default {
  name: 'Submit',
  props: {
    msg: String
  },
  components: {
    imageCropper
  },
  data() {
    return {
      showImageCropper: false,
      base_url: '',
      loading: false,
      submitted: false,
      noteType: 0,
      firstName: '',
      lastName: '',
      email: '',
      yourFirstName: '',
      yourLastName: '',
      errors: '',
      // previewLogoImgSrc: '',
      defaultSocialImage: '2019_POP_SocialShare.jpg',
      imageFileName:'',
      degree: 0,
      uploadFile: { 
          value: '', 
          newImage: 0 
        }, 
        publicPath: process.env.BASE_URL,
        messages: [
          [
            'Forever in my heart.',
            'Your inspiration lives on.',
            'Missing you every day.',
            'Words cannot express...',
            'I wear pink because of you.'
          ],
          [
            'You are in my prayers.',
            'Never give up.',
            'You are loved.',
            'You are an inspiration. ',
            'I wear pink because of you.',
            'Remission: Best. Word. Ever.',
            'You fought. You won. Hooray!',
            'I kicked cancer to the curb! ',
            'I won!',
            'I am proud to be a survivor.'
          ]
        ],
        selectedMessage: ''
    }
  },
  computed: {
    twitterUrl: function () {
      //<a href="https://twitter.com/home?status=https://app.brighton.com/power-of-pink/tmp/DQYat.jpg #PowerofPink #showyoucare #BrightonGivesBack">Tweet</a>
      if(this.imageFileName != '')
        return `https://twitter.com/home?status=https://app.brighton.com/power-of-pink/tmp/${this.imageFileName} #PowerofPink #showyoucare #BrightonGivesBack`
      else
        return `https://twitter.com/home?status=https://app.brighton.com/power-of-pink/${this.defaultSocialImage} #PowerofPink #showyoucare #BrightonGivesBack`
    },
    facebookUrl: function () {
      // <a href="https://www.facebook.com/sharer/sharer.php?u=https://app.brighton.com/power-of-pink/tmp/DQYat.jpg">Share</a>
      if(this.imageFileName != '')
        return `https://www.facebook.com/sharer/sharer.php?u=https://app.brighton.com/power-of-pink/tmp/${this.imageFileName}`
      else
        return `https://www.facebook.com/sharer/sharer.php?u=https://app.brighton.com/power-of-pink/${this.defaultSocialImage}`
    },
    pinterestUrl: function () {
      // <a href="https://pinterest.com/pin/create/button/?url=https://app.brighton.com/power-of-pink/tmp/DQYat.jpg&media=&description=#PowerofPink #showyoucare #BrightonGivesBack">Save</a>
      if(this.imageFileName != '')
        return `https://pinterest.com/pin/create/button/?url=https://app.brighton.com/power-of-pink/tmp/${this.imageFileName}&media=&description=#PowerofPink #showyoucare #BrightonGivesBack`
      else
        return `https://pinterest.com/pin/create/button/?url=https://app.brighton.com/power-of-pink/${this.defaultSocialImage}&media=&description=#PowerofPink #showyoucare #BrightonGivesBack`
    },

  },
  mounted(){
    this.base_url = process.env.BASE_URL
    this.$forceUpdate()

    this.firstName = this.$store.state.firstName
    this.lastName = this.$store.state.lastName
    this.noteType = this.$store.state.noteType
    this.selectedMessage = this.$store.state.selectedMessage == '' ? this.messages[this.noteType][0] : this.$store.state.selectedMessage
    this.yourFirstName = this.$store.state.yourFirstName
    this.yourLastName = this.$store.state.yourLastName
    this.email = this.$store.state.email


  },
  methods: {
    editImage() {
      this.loading = true
      this.$forceUpdate()
      this.$store.commit('setFirstName', this.firstName)
      this.$store.commit('setLastName', this.lastName)
      this.$store.commit('setNoteType', this.noteType)
      this.$store.commit('setSelectedMessage', this.selectedMessage)
      this.$store.commit('setYourFirstName', this.yourFirstName)
      this.$store.commit('setYourLastName', this.yourLastName)
      this.$store.commit('setEmail', this.email)
      if(this.noteType == 0)
        this.$store.commit('setMaskImage', this.base_url+"Heart_Transparent_LightPink.png")
      else
        this.$store.commit('setMaskImage', this.base_url+"Heart_Transparent_HotPink.png")
      this.$nextTick(()=>{
        this.$router.push({ path: 'edit' })
      })
    },
    getOrientation(file, callback) {
       var reader = new FileReader();
      reader.onload = function(event) {
        var view = new DataView(event.target.result);

        if (view.getUint16(0, false) != 0xFFD8) return callback(-2);

        var length = view.byteLength,
            offset = 2;

        while (offset < length) {
          var marker = view.getUint16(offset, false);
          offset += 2;

          if (marker == 0xFFE1) {
            if (view.getUint32(offset += 2, false) != 0x45786966) {
              return callback(-1);
            }
            var little = view.getUint16(offset += 6, false) == 0x4949;
            offset += view.getUint32(offset + 4, little);
            var tags = view.getUint16(offset, little);
            offset += 2;

            for (var i = 0; i < tags; i++)
              if (view.getUint16(offset + (i * 12), little) == 0x0112)
                return callback(view.getUint16(offset + (i * 12) + 8, little));
          }
          else if ((marker & 0xFF00) != 0xFF00) break;
          else offset += view.getUint16(offset, false);
        }
        return callback(-1);
      };

      reader.readAsArrayBuffer(file.slice(0, 64 * 1024));
    },
    changeNoteType(noteType){
      this.noteType = noteType
      this.selectedMessage = this.messages[noteType][0]
    },
    removeImage() {
      this.uploadFile = { 
          value: '', 
          newImage: 0 
      }
      document.getElementById('uploadFile').value = ''
      this.$store.commit('setSrcImage', '')
      this.$store.commit('setPreviewImage', '')
    },
    prepareFile(files) {
      if(files.length == 0)
        return false
      this.uploadFile.value = files 
      this.uploadFile.newImage = 0 
      if( 
          this.uploadFile.value[0].type.toString().indexOf('image') == -1 ||  
          ( 
              this.uploadFile.value[0].type.toString().indexOf('jpeg') == -1 && 
              this.uploadFile.value[0].type.toString().indexOf('bmp') == -1 && 
              this.uploadFile.value[0].type.toString().indexOf('gif') == -1 && 
              this.uploadFile.value[0].type.toString().indexOf('png') == -1 
          ) 
      ) { 
          this.errors = []
          this.errors.push('Invalid File Format.  Supports JPEG / PNG / GIF / BMP image format')
          return false 
      } 
      this.loading = true
      this.getOrientation(files[0], (orientation)=>{
        let moveX= 0, moveY = 0, imageWidth, imageHeight
        let that = this 
        this.uploadFile.newImage = true 
        var fReader = new FileReader(); 
        fReader.readAsDataURL(files[0]); 
        fReader.onloadend = (event)=>{ 
            let img = new Image(), that = this 
            img.src= event.target.result
            
            var maskImage = new Image();
            maskImage.onload = function (){
              var newCanvas = document.createElement('canvas'); 
              newCanvas.width  = maskImage.width ; 
              newCanvas.height = maskImage.height ; 
              var newCtx = newCanvas.getContext('2d') ; 
              newCtx.save      () ; 

              // rotate image based on orientation so it will always appears straight.
              //  orientation = 0
              switch(orientation) {
                case 6:
                  that.degree = 90
                  imageWidth = img.width >= maskImage.width ? maskImage.width : img.width
                  imageHeight = imageWidth * img.height / img.width
                  moveX = imageHeight > maskImage.width ? (imageHeight - ( (imageHeight - maskImage.width) /2)) : (maskImage.width - imageHeight) / 2 + imageHeight
                  moveY = imageWidth > maskImage.height ? ( -((imageWidth - maskImage.height ) / 2)) : ((maskImage.height - imageWidth) / 2 )
                  break;
                case 8:
                  that.degree = -90
                  imageWidth = img.width >= maskImage.width ? maskImage.width : img.width
                  imageHeight = imageWidth * img.height / img.width
                  moveX = imageHeight > maskImage.width ? (-( (imageHeight - maskImage.width) /2)) : (maskImage.width - imageHeight) / 2 
                  moveY = imageWidth > maskImage.height ? (imageWidth - ((imageWidth - maskImage.height ) / 2)) : ((maskImage.height - imageWidth) / 2 ) + imageWidth
                  break;

                  break;
                case 3:
                  that.degree = 180
                  imageWidth = img.width >= maskImage.width ? maskImage.width : img.width
                  imageHeight = imageWidth * img.height / img.width
                  moveX = imageWidth > maskImage.width ?  ( -((imageWidth - maskImage.Width ) / 2)) : ((maskImage.width - imageWidth ) / 2) + imageWidth
                  moveY = imageHeight > maskImage.height ? (imageHeight - ((imageHeight - maskImage.height ) / 2)) : ((maskImage.height /2 + imageHeight /2))
                  break;
                default:
                  that.degree = 0
                  imageWidth = img.width >= maskImage.width ? maskImage.width : img.width
                  imageHeight = imageWidth * img.height / img.width
                  moveX = imageWidth > maskImage.width ?  ( -((imageWidth - maskImage.Width ) / 2)) : ((maskImage.width /2 - imageWidth /2))
                  moveY = imageHeight > maskImage.height ? ( -((imageHeight - maskImage.height ) / 2)) : ((maskImage.height /2 - imageHeight /2))
              }

              newCtx.translate ( moveX, moveY) ; 
              newCtx.rotate  (that.degree*(Math.PI/180)); 
              // newCtx.drawImage ( img, 0, 0, img.width, img.height, 0, 0, maskImage.width, (maskImage.width * img.height) / img.width) ;  
              newCtx.drawImage ( img, 0, 0, img.width, img.height, 0, 0, imageWidth, imageHeight) ;  
              newCtx.rotate  (-that.degree*(Math.PI/180)); 
              newCtx.translate ( -moveX, -moveY) ;
              // draw mask
              newCtx.drawImage ( maskImage, 0,0) ; 
              newCtx.restore   () ; 
              that.$store.commit('setSrcImage', img.src)
              that.$store.commit('setPreviewImage', newCanvas.toDataURL())
              that.loading = false
            }


            if(this.noteType == 0)
              maskImage.src = this.base_url+"Heart_Transparent_LightPink.png";
            else
              maskImage.src = this.base_url+"Heart_Transparent_HotPink.png";
        }
      })
    },
    submitDedication() {
      this.errors = []
      if(this.firstName.trim() == '')
        this.errors.push('First name is required')
      if(this.lastName.trim() == '')
        this.errors.push('Last name is required')
      
      if(this.email.trim() != '' && /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email.trim()) == false)
        this.errors.push('Email is invalid' + this.email.trim())


      if(this.errors.length > 0) {
        window.scrollTo(0, 0);
        return false
      }

      
        
      var formData = new FormData();
      // var that = this
      formData.append('noteType', this.noteType)
      formData.append('email', this.email)
      formData.append('firstName', this.firstName)
      formData.append('lastName', this.lastName)
      formData.append('yourFirstName', this.yourFirstName)
      formData.append('yourInitial', this.yourLastName)
      formData.append('selectedMessage', this.selectedMessage)
      formData.append('previewLogoImgSrc', this.$store.state.previewImageSrcDataURL)
      this.loading = true
      axios( 
      {
        method: 'POST',
        url: `https://app.brighton.com/power-of-pink/api/submit`,
        responseType: 'json',
        data: formData,
        config: { headers: {'Content-Type': 'application/json' }}
      }).then((returnedData)=>{
        this.loading = false
        console.log(returnedData)
        if(returnedData.data.success.success) {
          this.submitted = true
          this.imageFileName = returnedData.data.success.imageFileName
          window.scrollTo(0, 400);
        } else if (returnedData.data.success.responseFromSF.error != undefined){
          this.errors.push(`Invalid email address: ${this.email}`)
          // this.errors.push(`Invalid email address: ${returnedData.data.success.responseFromSF.error}`)
          window.scrollTo(0, 0);
          return false
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss">
h3 {
  margin: 40px 0 0;
}
#trail{
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }

}

.container{
  position:relative;
  width:100%;
  a{
    /* text-decoration: none; */
  }
  #trail{
    clear: both;
    padding: 0 0 5px;
    margin: 0 auto 10px;
    border: none;
    overflow: hidden;
    ul{
      text-align:left;
      li{
        /* display: inline; */
        padding: 0 4px 0 10px;
        margin: 0 4px 0 0;
            padding-left: 1.25em;
            background: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHZpZXdCb3g9JzAgMCA3NiA2Ny40Jz48ZGVmcz48c3R5bGU+LmF7ZmlsbDojOTE5MTkxO308L3N0eWxlPjwvZGVmcz48dGl0bGU+aGVhcnQ8L3RpdGxlPjxwYXRoIGNsYXNzPSdhJyBkPSdNNzYsMTkuOGEyOC40NSwyOC40NSwwLDAsMS0yLDkuN0M2OC4zLDQzLjcsMzcuOCw2Ny40LDM3LjgsNjcuNFM4LDQ0LjUsMi4xLDI5LjRBMzAuNDksMzAuNDksMCwwLDEsMCwxOS44YTE5Ljc4LDE5Ljc4LDAsMCwxLDM4LTcuNywxOS43OCwxOS43OCwwLDAsMSwzOCw3LjdaJy8+PC9zdmc+) 0 center no-repeat;;
            background-position: 0 .25em;
            background-size: 1em;
      }
    }
    a{
      color: #000;
      font-size: 12px;
      font-weight: 700;
      letter-spacing: .08em;
      text-transform: uppercase;
    }
  }
  .staticPopTextWrapper{
    min-width: 300px;
    width: 84%;
    display: block;
    margin: 20px auto;
    text-align: center;
    .popButterflyTopSmallText{
      display: inline-block;
      position: relative;
      font-size: 87px;
      font-family: "Times New Roman", Times, serif;
      color: #F43A83;
      vertical-align: top;
      margin: 5px 2px 0;
      font-style: italic;
      line-height: 80px;
    }
    .popButterflyTopLargeText{
      display: inline-block;
      position: relative;
      font-size: 87px;
      font-family: 'Lato', sans-serif;
      color: #EE3E86;
      vertical-align: top;
      margin: 5px 2px 0;
      font-weight: bold;
      line-height: 80px;
    }
    .popButterflyTopYears{
      font: italic 30px/36px "Times New Roman", Times, serif;
      color: #000;
      display: block;
      margin: 10px 0 50px 0;
      font-weight: 600;
    }
    .popButterflyTopRecognition{
      display: block;
      position: relative;
      font: 900 16px/24px 'Lato', Arial, Helvetica, sans-serif;
      color: #000000;
      text-transform: uppercase;
      letter-spacing: 2px;
      margin: 0 auto;
      width:60%
    }
  }

  div.confirmation{
    display:block;
    margin-top:40px;
    span{
      display:block;
      color:#000;
      font-weight:bold;
    }
    img{
      margin-top:20px;
      max-width:100%;
    }
    button{
      font-size:18px;
      color: #000;
      text-transform: uppercase;
      display: block;
      background: #ee9cb8;
      /* max-width: 300px; */
      width:auto;
      margin: 20px auto;
      margin-top:0;
      padding: 3px;
      box-sizing:border-box;
      border:none;
      a{
        color:#000;
        font-size:16px;
        font-weight:bold;
        box-sizing:border-box;
        display:block;
        width:auto;
        padding-right: 30px;
        display:inline-block;
        vertical-align: middle;

        img{
          padding-right:30px;
          margin-top:0;
          width:auto;
          vertical-align: middle;
          display:inline-block;
        }
      }
    }
    .social{
      display: block;
      margin-top:50px;
      span.fa-stack{
        margin-top:5px;
        display:inline-block;
        vertical-align: middle;
      }
    }
  }
  div#pop_dedication{ 
    width: 90%;
    clear: both;
    display: block;
    margin: 0 auto;
    padding: 24px 0 48px;

    .errors{
      text-align:left;
      display:block;
      height: auto;
      clear: both;
      color: #fff;
      padding: 24px;
      margin: 3px 0 0;
      background: #f27cb6;
      font: 16px/21px 'Lato', Arial, Helvetica, sans-serif;
      ul{
        list-style-type: circle;
        li{
          /* display:block; */
        }
      }
    }
    button{
      border: 0;
      width: 50%;
      color: #fff;
      margin: 0 auto;
      display: block;
      padding: 18px 0;
      cursor: pointer;
      overflow: hidden;
      font: 24px/26px 'Muli', Arial, Helvetica, sans-serif;
      -moz-border-radius: 3px;
      -webkit-border-radius: 3px;
      -khtml-border-radius: 3px;
      border-radius: 3px;
      background: #b2b2b2;
      background: -moz-linear-gradient(top, #b2b2b2 0%, #858585 100%);
      background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,#b2b2b2), color-stop(100%,#858585));
      background: -webkit-linear-gradient(top, #b2b2b2 0%,#858585 100%);
      background: -o-linear-gradient(top, #b2b2b2 0%,#858585 100%);
      background: -ms-linear-gradient(top, #b2b2b2 0%,#858585 100%);
      background: linear-gradient(to bottom, #b2b2b2 0%,#858585 100%);
      filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#b2b2b2', endColorstr='#858585',GradientType=0 );
    }
    button.submitBtn span{
      display:inline-block;
    }
    .menu:hover,
    .menu.active{
      opacity:1;
    }
    .menu{
      opacity:0.8;
      transition: opacity 0.3s;
      cursor: pointer;
      padding: 0;
      // width: 49%;
      width: calc(50% - 2px);
      color: #fff;
      margin: 1px;
      height: 60px;
      background: #666;
      text-align: center;
      white-space: nowrap;
      vertical-align: top;
      display: inline-block;
      text-decoration: none;
      /* border: 3px solid #666; */
      font: 21px/60px 'Muli', Arial, Helvetica, sans-serif;
    }
    span{
      clear: both;
      display: block;
      text-align: left;
      max-width:600px;
      /* width:55%; */
      font: normal 18px/23px 'Muli', Arial, Helvetica, sans-serif;
    }
    label,div.label{
        color: #000;
        font-size: 0;
        display: block;
        padding: 0 0 48px;
        text-align: center;
        select{
            width: calc(100% - 2px) !important;
            height: 50px !important;
        }
        input{
          width:50%;
        }
    
        input,
        select,
       
        {
            padding: 0;
            outline: 0;
            color: #666;
            width: calc(50% - 2px);
            margin: 1px;
            height: 44px;
            box-sizing:border-box;
            backround: #fafafa;
            vertical-align: top;
            display: inline-block;
            border: 3px solid #c2c2c2;
            font: normal 18px/44px 'Muli', Arial, Helvetica, sans-serif;
                text-indent: 12px;
        }
    }
    label.emailSignup{
      text-align:left;
      span.remark{
        font-size:13px;
        font-weight:bold;
        line-height:1.3;
        padding-left:3px;
        a {
          text-decoration: underline;
          color:#666;
        }
      }
    }
    .uploadPhoto{
      color: #666;
      font-size: 0;
      position:relative;
      display: block;
      padding: 0 3px 48px 3px;
      text-align:left;
      .uploadArea{
        width:calc(50% - 2px);
        position:relative;
        height:100px;
        border:3px dotted #666;
        display:inline-block;
        vertical-align:top;
        padding-top:15px;
        box-sizing:border-box;
        input[type=file]{
        cursor: pointer;
          width:calc(100% - 2px);
          left:0;
          top:0;
          height:100%;
          position:absolute;
          opacity:0;
        }
        span{
          display:block;
          text-align:center;
          width:100%;
          font-size:15px;
          font-weight:bold;
        }
      }
      .uploadArea.edit:after {
        content: '';
        width:0;
        display:inline-block;
        height:100%;
        vertical-align: middle;
      }
      .uploadArea.edit {
        height:auto;
        padding:10px;
        box-sizing:Border-box;
        margin-right:20px;
        height:100px;

        #uploadFile{
          width:68%;
          vertical-align:middle;
          /* z-index:1; */

        }
        span{
          color:#fff;
          background-color:#000;
        }
        span.text{
          display: inline-block;
          text-align: center;
          width: 65%;
          margin-right:20px;
          vertical-align: middle;
          border:1px solid #000;
          /* z-index: 2;
    position: relative; */
        }
        span.editBtn{
          display: inline-block;
          text-align: center;
          width: 27%;
          vertical-align: middle;
          border:1px solid #000;
          cursor: pointer;
        }
      }
      .uploadedPhoto{
        display:inline-block;
        vertical-align:middle;
        box-sizing:border-box;
        margin:0 20px;
        position:absolute;
        width:200px;
        right:17%;
        margin:0;
        top:0;
        margin-left:20px;
        i.fa{
          position:absolute;
          right:0;top:0;
          filter: drop-shadow(1px 2px 1px #ccc);
          font-size:20px;
          cursor: pointer;
          color:#000;
        }
        img.logoImg{
          display:block;
          width:auto;
          max-width:100%;
          background-color:#dc568f;
        }
      }
      
    }
  }
}
@media(max-width:867px) {
    /* .container div#pop_dedication label input, */
    .container div#pop_dedication .uploadPhoto .uploadArea,
  .container div#pop_dedication label.emailSignup input{
    width:100%;
  }
  .container div#pop_dedication .uploadPhoto .uploadArea.edit{
    margin:0;
  }
  .container div#pop_dedication .uploadPhoto .uploadedPhoto{
    margin: 10px auto;
    position: relative;
    right: 0;
    width: auto;
  }
  .container div#pop_dedication .uploadPhoto{
    text-align:center;
    padding:10px 0;
  }
}
@media(max-width:768px) {
  .container { 
    div#pop_dedication{
      padding: 0;
      span{
        line-height:21px;
        font-size:16px;
      }
    }
    .staticPopTextWrapper {
      margin:0 auto;
      width:auto;
      .popButterflyTopRecognition{
          width:80%;
      }
      .popButterflyTopYears{
        margin-bottom:10px;
      }
    }
  }
}
@media(max-width:550px) {
  .container div#pop_dedication .menu, .container div#pop_dedication .menu:hover,
  .container div#pop_dedication label input,
  .container div#pop_dedication div.label input,
  .container div#pop_dedication button{
    width:100%;
  }
  .container .staticPopTextWrapper {
    
    .popButterflyTopLargeText,
    .popButterflyTopSmallText {
      font-size:15vw;
      line-height:15vw;
    }
  }
  .container div#pop_dedication .uploadPhoto .uploadArea.edit span.text,
  .container div#pop_dedication .uploadPhoto .uploadArea.edit span.editBtn{
    display:block;
    width:100%;
    height:auto;
    font-size:18px;
    line-height:2em;
    margin:10px auto;
    font-weight:bold;
    /* margin:5px; */
    box-sizing:border-box;
  }
  .container div#pop_dedication .uploadPhoto .uploadArea.edit{
    height:auto;
  }
  .container div#pop_dedication .uploadPhoto .uploadArea.edit #uploadFile{
    width:100%;
    height:50%;
  }
}
@media(max-width:415px) {
  .container div.confirmation button a{
    font-size: 12px;
  }
}
@media(max-width:350px) {
  .container div.confirmation button {
    width:100%;
    text-align:left;
    a{
      padding-right:10px;
      img{
        padding-right:10px;
      }
    }
  }
}
</style>
